let initialRootDataModel = window.initialRootData;

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".js-export-pdf-btn").forEach((exportBtn) => {
    exportBtn.addEventListener("click", (event) => {

      document.querySelectorAll(".js-export-pdf-tools").forEach((tools) => {
        if (tools !== exportBtn.nextElementSibling) {
          tools.style.display = "none";
        }
      });

      const tools = exportBtn.nextElementSibling;
      if (tools && tools.classList.contains("js-export-pdf-tools")) {
        tools.style.display = tools.style.display === "none" ? "block" : "none";
      }
      event.stopPropagation();
    });
  });

  document.addEventListener("click", (event) => {
    if (event.target.closest('.js-export-pdf-tools')) {
      event.stopPropagation();
    }else{
      document.querySelectorAll(".js-export-pdf-tools").forEach((tools) => {
        tools.style.display = "none";
      });
    }
    
  });

  document.querySelectorAll(".js-download-pdf-btn").forEach((downloadBtn) => {
    downloadBtn.addEventListener("click", (event) => {
      const exportContainer = downloadBtn.closest(".js-export-pdf-container");
      const entityType = exportContainer.getAttribute("data-entity-type");
      const entityRef = exportContainer.getAttribute("data-entity-ref");

      const fileTypeInputs = exportContainer.querySelectorAll(".js-file-type");
      let selectedFileType = 0;
      fileTypeInputs.forEach((input) => {
        if (input.checked) {
          selectedFileType = input.value;
        }
      });

      let showPrice = false;
      let showLogo = false;

      exportContainer.querySelectorAll(".js-show-pdf-price").forEach((input) => {
        if (input.checked) {
          showPrice = true;
        }
      });

      exportContainer.querySelectorAll(".js-show-pdf-logo").forEach((input) => {
        if (input.checked) {
          showLogo = true;
        }
      });

      const query = {
        fileType: selectedFileType,
        showPrice: showPrice,
        showLogo: showLogo,
      };

      const queryString = Object.keys(query)
        .map((key) => `${key}=${query[key]}`)
        .join("&");

      const url = `/ticket/download/${entityType}/${entityRef}/?${queryString}`;
      window.open(url, "_blank");
    });
  });
});

function formatPrice(price) {
  if (price) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return 0;
  }
}

// get company credit
function getCompanyCredit() {
  $(".js-header-company-credit-refresh").attr("disabled", true);

  $.ajax({
    url: "/fa/userprofile/getcredit/",
    type: "Get",
  })
    .done(function (response) {
      if (response.model) {
        var formattedPrice = formatPrice(response.model.price) + " " + response.model.currencyTitle;

        $(".js-header-company-credit").html(formattedPrice);
      }

      $(".js-header-company-credit-refresh").attr("disabled", false);
    })
    .fail(function (error) {
      if (error.response.isSucceed) {
        showAlert(error.response.messages);
      }

      $(".js-header-company-credit-refresh").attr("disabled", false);
    });
}

// searches functions
window.GoToSearchPage = function (term, baseSearchLink) {
  term = term
    .replace("<", "")
    .replace(">", "")
    .replace("*", "")
    .replace("%", "")
    .replace("&", "")
    .replace(":", "")
    .replace("\\", "")
    .replace("?", "")
    .replace("+", "");
  if (term) $(location).attr("href", baseSearchLink + term);
};

window.GoToSearchTopic = function (term, baseSearchLink) {
  term = term
    .replace("<", "")
    .replace(">", "")
    .replace("*", "")
    .replace("%", "")
    .replace("&", "")
    .replace(":", "")
    .replace("\\", "")
    .replace("?", "")
    .replace("+", "");
  if (term) $(location).attr("href", baseSearchLink + term + "/category-topic");

  //  window.location.href = '/en/search/' + term + "/category-topic";
};

//search in header
var modelInitializer = new ModelInitializer();

var url = modelInitializer.Get("SearchLink");
var RootDataModel = modelInitializer.Get("RootData");

var headerMenu = document.querySelector(".js-header-menu");
var scrollDown = "is-scroll-down";
var scrollUp = "is-scroll-up";
var lastScroll = 0;

///masterViewModel
if (masterViewModel) {
  masterViewModel.booking = new Booking({});
}

// add item to user bookmark
window.itemBookmark = function (element, type, id, status = true) {
  if (RootDataModel.isUserAuthenticated) {
    var favoriteRequest = {
      EntityRef: Number(id),
      EntityType: Number(type),
      IsFavorit: status,
    };

    element.setAttribute("disabled", true);

    $.ajax({
      url: "/Utility/Favorite/add",
      data: favoriteRequest,
      type: "Post",
    })
      .done(function (response) {
        if (!response.isSucceed) {
          if (!response.isUserAuthenticated) {
            showAlert([{ type: 8, message: "لطفا وارد حساب کاربری خود شوید" }]);
          }

          return;
        }

        element.removeAttribute("disabled", true);

        showAlert(response.messages);

        element.classList.toggle("is-bookmarked");
      })
      .fail(function (error) {
        if (error.response.isSucceed) {
          showAlert(error.response.messages);
        }
      });
  } else {
    showAlert([{ type: 8, message: "لطفا وارد حساب کاربری خود شوید" }]);
  }
};

const fixHeaderReplacementSize = () => {
  const header = document.querySelector(".js-header-menu");

  document.querySelector(".js-header-replacement").style.height = `${header.offsetHeight}px`;

  if (!header.classList.contains("is-fixed")) header.classList.add("is-fixed");
};

$(function () {
  fixHeaderReplacementSize();

  $(document).on("keyup", ".js-input-search", function (e) {
    if (e.keyCode === 13) {
      var term = $(this).val();
      if (term) GoToSearchPage(term, url);
    }
  });

  //toggle menu
  $(".js-navbar-toggler").click(function () {
    var $this = $(this);

    if (!$(this).hasClass("open")) {
      $this.addClass("open");

      $this.closest(".js-header").addClass("open-nav");

      $("html").addClass("no-scroll");

      $(".js-account-sub-menu").removeClass("open");
    } else {
      $this.removeClass("open");

      $this.closest(".js-header").removeClass("open-nav");

      $("html").removeClass("no-scroll");
    }
  });

  //back from menu
  $(".js-menu-return").click(function () {
    $(".js-navbar-toggler").removeClass("open");

    $(".js-header").removeClass("open-nav");

    $("html").removeClass("no-scroll");
  });

  //toggle sub menu in MOBILE

  $(".js-menu-toggler").click(function () {
    if ($(this).next().length) {
      if (!$(this).next().is(":visible")) {
        $(".js-menu-toggler").next().slideUp();
      }

      $(this).next().slideToggle();
      $(this).toggleClass("open");
    }
  });

  //open search box
  $(".js-search-btn").on("click", function () {
    if ($(".js-header").hasClass("search-fade-in")) {
      $(".js-header").removeClass("search-fade-in").addClass("search-fade-out");

      $("body").removeClass("open-modal");
    } else {
      $(".js-header").addClass("search-fade-in").removeClass("search-fade-out");

      $("body").addClass("open-modal");
    }

    setTimeout(function () {
      $(".search-fade-in input[type='text']").trigger("focus");
    }, 400);
  });

  //close search box

  $("body").on("click", function (event) {
    if (!$(event.target).closest(".js-header").length) {
      $(".js-header").removeClass("search-fade-in").addClass("search-fade-out");

      $("body").removeClass("open-modal");
    }
  });

  //open submenu
  if ($(window).width() < 992) {
    $(".js-menu-with-sub-menu").click(function (e) {
      e.stopPropagation();

      $(this).toggleClass("open-sub-menu");
    });
  }

  //mouse move
  if ($(window).width() < 992) {
    $(".js-account-sub-menu").on("click", function () {
      if ($(this).hasClass("open")) {
        $(this).removeClass("open");
        $(this).next().hide();
        $("html").removeClass("no-scroll");
        $(".js-header-menu").removeClass("is-open");
      } else {
        $(this).next().show();
        $(".js-header-menu").addClass("is-open");
        $(this).addClass("open");
        $("html").addClass("no-scroll");
        $(".js-header").removeClass("open-nav");
        $(".js-navbar-toggler").removeClass("open");
      }
    });

    $(".js-account-sub-menu")
      .next()
      .find("a")
      .click(function () {
        if ($(".js-account-sub-menu").hasClass("open")) {
          $(".js-account-sub-menu").removeClass("open");
          $(".js-account-sub-menu").next().hide();
          $("html").removeClass("no-scroll");
        } else {
          $(".js-account-sub-menu").next().show();

          $(".js-account-sub-menu").addClass("open");
          $("html").addClass("no-scroll");
          $(".js-header").removeClass("open-nav");
          $(".js-navbar-toggler").removeClass("open");
        }
      });
  }

  // close alert
  $(".alert .close").click(function () {
    $(this).parent(".alert").remove();
  });

  //accordion
  $(".js-accordion").click(function () {
    $(this).next().slideToggle();
    $(this).toggleClass("accordion-open");
  });

  //toggle footer links
  $(".js-toggle-footer-links").click(function () {
    if (window.innerWidth < 993) $(this).next().slideToggle();
  });

  //open search in header
  $(".js-toggle-search").click(function () {
    $(this).next().show().addClass("js-search-active");
    var $this = $(this);

    setTimeout(function () {
      $this.next().find(".js-input-search").focus();
    }, 200);
  });
  //close search in header

  $("body").on("click", function (e) {
    if (e.target.className.includes("js-search-active")) {
      if (!$(e.target).closest(".js-search-input").length) {
        $(".js-search-active").fadeOut(100, function () {
          $(".js-search-active").removeClass("js-search-active");
        });
      }
    }

    if (!e.target.className.includes("js-bread-crumb-button")) {
      $(".js-bread-crumb").removeClass("open");
    }
  });

  // get company credit
  if ($(".js-header-company-credit-refresh").length) {
    getCompanyCredit();

    $(".js-header-company-credit-refresh").click(function () {
      getCompanyCredit();
    });

    $(".js-header-company-toggle").click(function () {
      $(".js-header-company").toggleClass("is-open");

      $(".js-header-menu").toggleClass("is-open");

      $("html").toggleClass("no-scroll");
    });
  }

  $(".js-banner-close").click(function () {
    $(this).closest(".js-banner").hide();
  });

  $(".js-newsletters-submit").click(function () {
    var contact = $(this).closest(".js-newsletters").find(".js-newsletters-input").val();

    var errorMsg = $(this).closest(".js-newsletters").find(".js-newsletters-error-msg");
    var successMsg = $(this).closest(".js-newsletters").find(".js-newsletters-success-msg");

    errorMsg.hide();
    successMsg.hide();

    if (!validateEmail(contact)) {
      errorMsg.show();
      errorMsg.text("لطفا ایمیل معتبر وارد کنید.");

      return false;
    }

    function sendNewsletterData(data) {
      $.ajax({
        type: "post",
        url: "/cms/newsletter/add/",
        data,
        success: function (data) {
          successMsg.show();
          successMsg.text(data.messages[0].message);

          showAlert(data.Messages);
        },
      });
    }

    if (initialRootDataModel.isActiveRecaptcha) {
      let reCaptchaCallBackFunction = () => {
        const data = { Email: contact };
        data[initialRootDataModel.reCaptchaInputName] = document.getElementById(initialRootDataModel.recaptchaElementId).value;

        sendNewsletterData(data);
      };

      window[initialRootDataModel.recaptchaFunctionName](reCaptchaCallBackFunction);
    } else {
      const data = { Email: contact };
      sendNewsletterData(data);
    }
  });

  //show all popular tourism
  $(".js-show-popular-tourism").click(function () {
    $(this).prevAll().fadeIn("fast");
    $(this).hide();
  });
});

var currentScroll = window.pageYOffset || document.documentElement.scrollTop;

if (currentScroll >= 121) {
  $("html").addClass(scrollUp);
}

window.addEventListener("resize", () => {
  fixHeaderReplacementSize();
});

window.addEventListener("scroll", () => {
  currentScroll = window.pageYOffset || document.documentElement.scrollTop;

  if (currentScroll <= 121) {
    headerMenu.classList.remove(scrollDown);

    return;
  }

  if (currentScroll > lastScroll && !headerMenu.classList.contains(scrollDown)) {
    headerMenu.classList.add(scrollDown);
    $("html").removeClass(scrollUp);
  } else if (currentScroll < lastScroll && headerMenu.classList.contains(scrollDown)) {
    headerMenu.classList.remove(scrollDown);
    $("html").addClass(scrollUp);
  }

  lastScroll = currentScroll;
});

//bread crumb toggle button
$(".js-bread-crumb-button").on("click", function () {
  const parent = $(this).closest(".js-bread-crumb");

  if (parent.siblings().hasClass("open")) {
    parent.siblings().removeClass("open");
  }
  parent.toggleClass("open");
});
